import OutlayDetailModal from './outlay-detail-modal.vue'
export default OutlayDetailModal
